document.addEventListener('bundler:loaded', function (e) {
  window.bndlr.updateCartDiscounts();
});

// Listen to the custom event for recalculated cart values
document.addEventListener('bundler:total_cart_values', function (e) {

  const detail = e.detail || {};
  const total_amount_original = Number(detail.total_amount_original);
  const total_amount_discounted = Number(detail.total_amount_discounted);
  const discount_amount = Number(detail.discount_amount);
  const discounted_cart_object = detail.discounted_cart_object || null;

  if (!Number.isFinite(total_amount_discounted)) {
    return;
  }


  // Update the cart subtotal (without VAT)
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const subtotalWithoutTax = (total_amount_discounted / 100).toFixed(2).replace('.', ','); // Assume 21% VAT
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `€${subtotalWithoutTax}`;
    // subtotalWithoutTaxElement.setAttribute('data-excl-price', `${total_amount_discounted / 1.21}`);
  }

  // Update the total tax element
  const totalTaxElement = document.getElementById('cart-price_tax');
  const totalTax = ((total_amount_discounted * 0.21) / 100).toFixed(2).replace('.', ','); // Calculate 21% VAT
  if (totalTaxElement) {
    totalTaxElement.textContent = `€${totalTax}`;
  } else {
    totalTaxElement.textContent = `€0,00`; // Fallback if calculation fails
  }
  

  // Update the total discount element
  const totalDiscountElement = document.getElementById('cart-price_discount');
  const totalDiscount = (discount_amount / 100).toFixed(2).replace('.', ',');
  if (totalDiscountElement) {
    totalDiscountElement.textContent = `-€${totalDiscount}`;
    // totalDiscountElement.setAttribute('data-excl-price', `${discount_amount}`);
  }

  // Update the total price element
  const totalPriceElement = document.getElementById('cart-price_total');
  const totalPrice = (total_amount_discounted * 1.21 / 100).toFixed(2).replace('.', ',');
  if (totalPriceElement) {
    totalPriceElement.textContent = `€${totalPrice}`;
    // totalPriceElement.setAttribute('data-excl-price', `${total_amount_discounted}`);
  }

  // Check if discounted_cart_object exists before trying to access its items
  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      
      // Find the relevant cart item element by its variant ID or another unique identifier
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`);
      
      if (itemElement) {
        // Update the original price display
        const oldPriceElement = itemElement.querySelector('[data-old-price]');
        if (oldPriceElement) {
          oldPriceElement.textContent = `€${(item.original_price * item.quantity / 100).toFixed(2).replace('.', ',')}`;
          oldPriceElement.setAttribute('data-excl-price', `${(item.original_price * item.quantity)}`);
        }

        // Update the new price display
        const newPriceElement = itemElement.querySelector('[data-new-price]');
        if (newPriceElement) {
          newPriceElement.textContent = `€${(item.line_price / 100).toFixed(2).replace('.', ',')}`;
          newPriceElement.setAttribute('data-excl-price', `${(item.line_price)}`);
        }
      } else {
        console.warn(`Cart item element not found for variant ID: ${item.variant_id}`);
      }
    });
  } else {
    console.warn('Discounted cart object is undefined or missing items.');
  }
});
